export default "__VITE_ASSET__4c7e679b__"